interface TranslationMap {
  [key: string]: string;
}

/**
 * Resolves a value that might be a translation key or a literal string
 * @param value - The value to resolve (could be a translation key like 'app.title' or literal text)
 * @param translations - The translation map for the current language
 * @param fallback - Optional fallback value if translation not found
 * @returns The translated value or the original value if not a translation key
 */
export function resolveTranslationKey(
  value: string,
  translations: TranslationMap,
  fallback?: string
): string {
  // Check if the value looks like a translation key (contains dots and is not too long)
  if (value && value.includes('.') && value.length < 100 && !value.includes(' ') && !value.includes('\n')) {
    // It's likely a translation key, try to look it up
    return translations[value] || fallback || value;
  }

  // It's a literal value, return as-is
  return value;
}

/**
 * Checks if a string looks like a translation key
 */
export function isTranslationKey(value: string): boolean {
  return value && value.includes('.') && value.length < 100 && !value.includes(' ') && !value.includes('\n');
}
